import React from 'react'
import { Fab, Typography } from '@mui/material'
import { DoneOutlineOutlined } from '@mui/icons-material'
import { Stack } from '@mui/system'
import { blue } from '../../colors'
import CustomHeader from '../../components/CustomHeader'
import PAGE_TITLES from '../../consts/titles'
import CenteredContainer from '../../components/CenteredContainer'

export const SurveyCompletedPagePublic: React.FC = (): JSX.Element => {
  return (
    <CenteredContainer>
      <CustomHeader title={PAGE_TITLES.SURVEY_COMPLETED_PUBLIC} />
      <Stack sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center'
      }}>
        <Fab disableRipple sx={{
          backgroundColor: blue[100],
          color: 'primary.main',
          boxShadow: 0,
          pointerEvents: 'none'
        }}>
          <DoneOutlineOutlined />
        </Fab>
        <Typography sx={{ fontWeight: 'bold', fontSize: '20px' }}>
          Thank you for participating!<br/>
           Your survey has been submitted successfully.
        </Typography>
      </Stack>
    </CenteredContainer>
  )
}
